import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const AuthCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/login", {
      state: { isSsoRedirect: true },
      replace: true,
    });
  }, [navigate]);

  return null;
};

export const SilentAuthCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/login", {
      state: { isSsoRedirect: true },
      replace: true,
    });
  }, [navigate]);
  return null;
};
